import { ReactElement } from 'react';
import { SiteSummarySSList } from '../../components/siteSummaryKaeSS/siteSummarySS';
import '@assets/styles/pages/site-summary-page.scss';

export const SiteSummarySS = (): ReactElement => {
	return <SiteSummarySSList />;
};
